import React, {useEffect, useState} from 'react'

import {
    CapsuleContainer,
    CapsulasImg,
    PokemonImgFondo,
    PokemonImgFrente,
    PokemonGashaContainer,
    PokemonGashaBall
} from './styles'

import CAPSULASBACK from '../../../../../Assets/pelotasfondo.png'
import CAPSULASFRONT from '../../../../../Assets/pelotasfrente.png'
import GASHAPONBALL from '../../../../../Assets/gashaponball.png'
const POKEIMAGENESURL = import.meta.env.VITE_POKEIMAGENES_URL;

export const Capsulas = ({pokemon, imagenesCache}) => {
    const [imageCache, setImageCache] = useState({});
  // Precargar imágenes
      useEffect(() => {
          const cache = {};
          pokemon && pokemon.forEach(item => {
              const url = POKEIMAGENESURL.replaceAll('NOMBREPOKEMON',item.poke_nombre);
              const img = new Image();
              img.src = url;
              cache[item.poke_id] = img.src;
          });
          setImageCache(cache);
      }, [pokemon]);

  const getRandomElements = (array, count) => {
    const result = [];

    if (array.length === 0) return result;
    const weightedArray = array.flatMap(item => {
        const weight = Math.max(1, Math.round(item.probabilidad));
        return Array(weight).fill(item);
    });
    while (result.length < count) {
        const randomIndex = Math.floor(Math.random() * weightedArray.length);
        result.push(weightedArray[randomIndex]);
    }
    return result;
  };

  const [pokemonFondo, setPokemonFondo] = useState(getRandomElements(pokemon, 9));
  const [pokemonFrente, setPokemonFrente] = useState(getRandomElements(pokemon, 8));
  return (
    <CapsuleContainer >
      {
        pokemonFondo.map((poke, index) => <PokemonImgFondo key={index} src={imageCache[poke.poke_id]} index={index} />)
      }
      <CapsulasImg src={imagenesCache[6]}/>
      {
        pokemonFrente.map((poke, index) => <PokemonImgFrente key={index} src={imageCache[poke.poke_id]} index={index} />)
      }
      <CapsulasImg src={imagenesCache[7]}/>
    </CapsuleContainer>
    
  )
}

export const CapsulaChoosen = ({pokemon, translate, setPreChoise, preChoise = null}) => {
  return (
    <PokemonGashaContainer translate={translate}  onClick={() => setPreChoise(pokemon)}>
      <PokemonGashaBall src={POKEIMAGENESURL.replaceAll('NOMBREPOKEMON',pokemon.nombre)} opacity={1}/>
      <PokemonGashaBall src={GASHAPONBALL} opacity={0.6} ball={1} focus={preChoise?.numeroDex === pokemon.numeroDex ? 1 : 0}/>
    </PokemonGashaContainer>
  )
}

